export const parsePhone = (number, city = null) => {
    if (!number) return { e164: null, local: null };

    // Clean all non-digit characters except '+' at the start
    const cleanNumber = number.replace(/(?!^\+)[^\d]/g, '');

    let e164 = null;

    switch (true) {
        // Peru 1XY (Emergencias)
        case /^1[0-9]{2}$/.test(cleanNumber):
            e164 = cleanNumber;
            break;
        // Peru 80...
        case /^80[0-9]{6}$/.test(cleanNumber):
            e164 = `51${cleanNumber}`;
            break;
        case /^5180[0-9]{6}$/.test(cleanNumber):
            e164 = cleanNumber;
            break;
        case /^080[0-9]{6}$/.test(cleanNumber):
            e164 = `51${cleanNumber.substring(1)}`;
            break;
        // Fijo/Rural Lima
        case /^[2-9][0-9]{6}$/.test(cleanNumber):
            e164 = `511${cleanNumber}`;
            break;
        case /^1[2-9][0-9]{6}$/.test(cleanNumber):
            e164 = `51${cleanNumber}`;
            break;
        case /^01[2-9][0-9]{6}$/.test(cleanNumber):
            e164 = `51${cleanNumber.substring(1)}`;
            break;
        case /^001[2-9][0-9]{6}$/.test(cleanNumber):
            e164 = `51${cleanNumber.substring(2)}`;
            break;
        case /^511[2-9][0-9]{6}$/.test(cleanNumber):
            e164 = cleanNumber;
            break;
        case /^0511[2-9][0-9]{6}$/.test(cleanNumber):
            e164 = cleanNumber.substring(1);
            break;
        case /^00511[2-9][0-9]{6}$/.test(cleanNumber):
            e164 = cleanNumber.substring(2);
            break;
        case /^11[2-9][0-9]{6}$/.test(cleanNumber):
            e164 = `5${cleanNumber}`;
            break;
        // Peru Movil
        case /^9[0-9]{8}$/.test(cleanNumber):
            e164 = `51${cleanNumber}`;
            break;
        case /^09[0-9]{8}$/.test(cleanNumber):
            e164 = `51${cleanNumber.substring(1)}`;
            break;
        case /^009[0-9]{8}$/.test(cleanNumber):
            e164 = `51${cleanNumber.substring(2)}`;
            break;
        case /^0009[0-9]{8}$/.test(cleanNumber):
            e164 = `51${cleanNumber.substring(3)}`;
            break;
        case /^519[0-9]{8}$/.test(cleanNumber):
            e164 = cleanNumber;
            break;
        case /^0519[0-9]{8}$/.test(cleanNumber):
            e164 = cleanNumber.substring(1);
            break;
        case /^00519[0-9]{8}$/.test(cleanNumber):
            e164 = cleanNumber.substring(2);
            break;
        // Peru Fijo/Rural LDN (Provincias)
        case /^[4-8][0-9][2-9][0-9]{5}$/.test(cleanNumber):
            e164 = `51${cleanNumber}`;
            break;
        case /^0[4-8][0-9][2-9][0-9]{5}$/.test(cleanNumber):
            e164 = `51${cleanNumber.substring(1)}`;
            break;
        case /^51[4-8][0-9][2-9][0-9]{5}$/.test(cleanNumber):
            e164 = cleanNumber;
            break;
        case /^051[4-8][0-9][2-9][0-9]{5}$/.test(cleanNumber):
            e164 = cleanNumber.substring(1);
            break;
        case /^0051[4-8][0-9][2-9][0-9]{5}$/.test(cleanNumber):
            e164 = cleanNumber.substring(2);
            break;
        // Fijo Local (requiere ciudad)
        case /^[2-9][0-9]{5}$/.test(cleanNumber):
            if (city) {
                e164 = `51${city}${cleanNumber}`;
            }
            break;
        // LDI (Internacional)
        case /^0[1-9][0-9]{9,20}$/.test(cleanNumber):
            e164 = cleanNumber.substring(1);
            break;
        case /^00[1-9][0-9]{9,20}$/.test(cleanNumber):
            e164 = cleanNumber.substring(2);
            break;
        case /^000[1-9][0-9]{9,20}$/.test(cleanNumber):
            e164 = cleanNumber.substring(3);
            break;
        case /^0000[1-9][0-9]{9,20}$/.test(cleanNumber):
            e164 = cleanNumber.substring(4);
            break;
        case /^\+[1-9][0-9]{9,20}$/.test(cleanNumber):
            e164 = cleanNumber.substring(1);
            break;
        case /^\+00[1-9][0-9]{9,20}$/.test(cleanNumber):
            e164 = cleanNumber.substring(3);
            break;
        case /^[1-9][0-9]{9,20}$/.test(cleanNumber):
            e164 = cleanNumber;
            break;
    }

    let local = null;
    if (e164) {
        if (/^51/.test(e164)) {
            local = e164.substring(2);
        } else {
            local = e164;
        }
    }

    return { e164, local };
};

export const toE164 = (number, city = null) => {
    return parsePhone(number, city).e164;
};

export const toLocal = (number, city = null) => {
    return parsePhone(number, city).local;
};
